angular.module('unergie.main')
.directive('adminContent', ($sce, ApiUser, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/adminContent/adminContent.html',
        scope: {
            contentId: '=',
        },
        link($scope) {
            $scope.fetchingContent = true
            ApiUser.getAdministrableContent({ contentId: $scope.contentId }).$promise.then((adminContent) => {
                $scope.content = adminContent && adminContent.content
            }).catch(ErrorCatcher)
            .finally(() => {
                $scope.fetchingContent = false
            })
        },
    })
)
